import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Col, Divider, Flex, Row, Space, Tabs, Button, ConfigProvider } from "antd";
import { DatePicker, Input, Select } from "components/form";

import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/swapShiftSchema";
import dayjs from "dayjs"
import { useEffect, useState } from "react";

function SwapShiftForm({
  startDate = null,
  className = "",
  modalType = "view",
  myCurrentShift = [],
  newShiftRequest = [],
  initialValues = {},
  switchByOptions = [],
  c = [],
  switchWithOptions = [],
  onDraft = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  onChange = () => { },
  onSwitchWithChange = () => { },
  approver = [],
  onTypeChange = () => { },
  changeShiftType = "",
  swapChangeShift = "",
  attendanceSettingShift = []
}) {

  function formatDate(dateString, pattern = "DD-MM-YYYY") {
    if (!dateString) return;
    const date = dayjs(dateString, pattern);
    return date.format("DD-MM-YYYY");
  }

  const [formType, setformType] = useState(initialValues?.changeShiftType ? initialValues?.changeShiftType : changeShiftType)
  console.log("initialValues", initialValues)
  useEffect(() => {
    setformType(changeShiftType || initialValues?.changeShiftType)
  }, [changeShiftType, initialValues?.changeShiftType])
  const { t } = useTranslation();
  const changeShiftItem = [
    {
      key: 'SWAP',
      label: t('changeshift.label.swapshift')
    },
    {
      key: 'CHANGE',
      label: t('changeshift.label.changeshift')
    },
  ];
  return (
    <Formik
      enableReinitialize

      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
        switchBy: switchByOptions?.[0]?.id,
        from: myCurrentShift?.[0]?.shiftId,
        approver: approver?.[0]?.empId ? approver?.[0]?.empId : approver?.[0]?.id,
        startDate: initialValues?.startDate ? dayjs(initialValues?.startDate) : startDate,
        endDate: initialValues?.endDate ? dayjs(initialValues?.endDate) : null,
        switchWith: initialValues?.switchWithBy ? initialValues?.switchWithBy?.name : approver?.[0]?.id,
        to: newShiftRequest?.[0]?.shiftId,
        other: initialValues?.description
      }}
      onSubmit={(values) => {
        const modifiedValues = {
          ...values,
          startDate: values?.startDate ? dayjs(values?.startDate).format("YYYY-MM-DD") : null,
          endDate: values?.endDate ? dayjs(values?.endDate).format("YYYY-MM-DD") : null
        }
        console.log("modifiedValues", modifiedValues)
        onSubmit(modifiedValues)
      }}
      validationSchema={schema}
    >

      {({ values = {}, resetForm = () => { } }) => {
        return (
          <Form className={className}>
            {/* <Divider /> */}
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              {swapChangeShift === '' || swapChangeShift === null ?
                <ConfigProvider theme={{
                  components: {
                    Tabs: {
                      itemHoverColor: "var(--tab-color)",
                      itemActiveColor: "var(--tab-color)"
                    },
                  },
                }}>
                  <Tabs activeKey={formType} items={changeShiftItem} onChange={onTypeChange} /></ConfigProvider>
                : null

              }
              {(((swapChangeShift === null || swapChangeShift === '') || swapChangeShift === 'SWAP') && (formType === 'SWAP' || swapChangeShift === 'SWAP')) ? (
                <Row gutter={[0, 12]}>
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <Select
                      name="switchBy"
                      label={t('changeshift.label.switchby')}
                      placeholder={t('common.pleaseSelect')}
                      size="large"
                      options={switchByOptions}
                      disabled
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <Select
                      disabled={modalType == 'view'}
                      name="switchWith"
                      label={t('changeshift.label.switchwith')}
                      placeholder={t('common.pleaseSelect')}
                      size="large"
                      options={switchWithOptions}
                      onChange={(_, item) => {
                        onSwitchWithChange(item)
                      }}
                    />
                  </Col>
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <DatePicker
                      disabled={modalType == 'view'}
                      name="startDate"
                      label={t('changeshift.label.startdate')}
                      placeholder={t('common.placeholder.ddmmyyyy')}
                      size="large"
                      format={formatDate()}
                      onChange={onChange}
                      min={dayjs().startOf("year")}
                      max={dayjs().endOf("year")}
                      required
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <DatePicker
                      disabled={modalType == 'view'}
                      name="endDate"
                      label={t('changeshift.label.enddate')}
                      placeholder={t('common.placeholder.ddmmyyyy')}
                      size="large"
                      format={formatDate()}
                      max={dayjs().endOf("year")}
                    />
                  </Col>
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <Select
                      name="from"
                      label={t('changeshift.label.currentshift')}
                      placeholder={t('changeshift.label.currentshift')}
                      size="large"
                      options={myCurrentShift}
                      disabled
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <Select
                      name="to"
                      label={t('changeshift.label.newshift')}
                      placeholder={t('changeshift.label.newshift')}
                      size="large"
                      options={newShiftRequest}
                      disabled
                    />
                  </Col>
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <Input
                      disabled={modalType == 'view'}
                      name="other"
                      label={t('expense.lable.reason')}
                      placeholder={t('expense.lable.pls_fill_reason')}
                      size="large"
                      required
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <Select
                      name="approver"
                      label={t('changeshift.label.approver')}
                      placeholder={t('changeshift.label.approver')}
                      size="large"
                      options={approver}
                      disabled
                    />
                  </Col>
                </Row>
              ) : (
                <Row gutter={[0, 12]}>
                  {/* <Col span={12}>
                    <Select
                      name="switchBy"
                      label={t('changeshift.label.switchby')}
                      placeholder={t('common.pleaseSelect')}
                      size="large"
                      options={switchByOptions}
                      disabled
                    />
                  </Col> */}
                  {/* <Col span={12}>
                    <Select
                      name="switchWith"
                      label={t('changeshift.label.switchwith')}
                      placeholder={t('common.pleaseSelect')}
                      size="large"
                      options={switchWithOptions}
                      onChange={(_, item) => {
                        onSwitchWithChange(item)
                      }}
                    />
                  </Col> */}

                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <DatePicker
                      disabled={modalType == 'view'}
                      name="startDate"
                      label={t('changeshift.label.startdate')}
                      placeholder={t('common.placeholder.ddmmyyyy')}
                      size="large"
                      format={formatDate()}
                      onChange={onChange}
                      required
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <DatePicker
                      disabled={modalType == 'view'}
                      name="endDate"
                      label={t('changeshift.label.enddate')}
                      placeholder={t('common.placeholder.ddmmyyyy')}
                      size="large"
                      format={formatDate()}
                    />
                  </Col>
                  <Col span={12} style={{ paddingRight: "8px" }}>
                    <Select
                      name="from"
                      label={t('changeshift.label.currentshift')}
                      placeholder={t('changeshift.label.currentshift')}
                      size="large"
                      options={myCurrentShift}
                      disabled
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "8px" }}>
                    <Select
                      disabled={modalType == 'view'}
                      name="to"
                      label={t('changeshift.label.newshift')}
                      placeholder={t('changeshift.label.newshift')}
                      size="large"
                      options={attendanceSettingShift}
                    />
                  </Col>
                  <Col span={24}>
                    <Input
                      disabled={modalType == 'view'}
                      name="other"
                      label={t('expense.lable.reason')}
                      placeholder={t('expense.lable.pls_fill_reason')}
                      size="large"
                      type="textarea"
                      required
                    />
                  </Col>
                </Row>
              )}


              <Row justify="end">
                <Space direction="horizontal" size={12}>
                  <Button
                    id="mst__cancelBtn"
                    type="default"
                    onClick={() => {
                      resetForm();
                      onCancel();
                    }}
                    style={{ height: "40px", borderRadius: "8px" }}
                  >
                    {t("common.cancel")}
                  </Button>
                  {modalType == 'view' ? null :
                    <><Button
                      id="mst__cancelBtn"
                      type="default"
                      onClick={() => onDraft(values)}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.draft")}
                    </Button><Button htmlType="submit"
                      type="primary"
                      style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", boxShadow: "none" }}
                    >
                        {t("my_timesheet.label.approve")}
                      </Button></>
                  }
                </Space>
              </Row>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SwapShiftForm;
